export default __webpack_public_path__ + "static/media/34_moonwalker.2abba172.png";